import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import track from 'react-tracking';
import { connect } from 'react-redux';
import { ButtonList } from 'components';
import { LayoutChat } from 'layouts';
import { COMPONENT_TYPE, PATH } from 'shared/constants';
import { getRTL } from 'shared/redux/selectors';
import {
  submitReply, clearConversationHistory, updateSummary, updateStep,
} from 'shared/redux/actions';
import iconClose from 'assets/icons/iconTopbarClose.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedo } from '@fortawesome/free-solid-svg-icons';
import trackEvent from 'components/TrackEvent/TrackEvent';
import { eventInvestmentPreferenceSharia, eventInvestmentPreferenceCountry } from 'components/TrackEvent/constEvent';


import { trackGeographicalInvestment, trackRegulatoryInvestor, trackIslamicInvestor } from './InvestmentPreference.tracking';

class InvestmentPreference extends Component {
   closeInvestorProfile = () => {
     const {
       history,
     } = this.props;
     history.push(PATH.JOURNEY_OVERVIEW);
   };

    handleRestart = () => {
      const { onClearConversationHistory, onReplySubmit } = this.props;
      onClearConversationHistory().then(() => onReplySubmit('restart'));
    };

    processGeographicalReply = (reply) => {
      const { intl } = this.props;
      let value = [];
      if (reply.includes('askGeographically.convo.quick_replies.3')) {
        value.push(intl.formatMessage({ id: 'askGeographically.convo.quick_replies.3' }));
      }
      if (reply.includes('askGeographically.convo.quick_replies.2')) {
        value.push(intl.formatMessage({ id: 'askGeographically.convo.quick_replies.2' }));
      }
      if (reply.includes('askGeographically.convo.quick_replies.4')) {
        value.push(intl.formatMessage({ id: 'askGeographically.convo.quick_replies.4' }));
      }
      if (reply.includes('askGeographically.convo.quick_replies.5')) {
        value.push(intl.formatMessage({ id: 'askGeographically.convo.quick_replies.5' }));
      }
      // if (reply.includes('yes_gold')) {
      //   value.push(intl.formatMessage({ id: 'askGeographically.convo.quick_replies.5' }));
      // }
      value = value.join(', ');
      return value;
    }

    render() {
      const {
        conversations,
        inputComponent,
        inputOptions,
        onReplySubmit,
        onUpdateSummary,
        CMAClassification,
        isRtl,
        tracking,
        intl,
        currentLocale,
        summary
      } = this.props;

      let input;

      switch (inputComponent) {
        case COMPONENT_TYPE.ISLAMIC_INVESTMENT:
          input = (
            <ButtonList
              optionList={inputOptions}
              onOptionClick={(reply) => {
                onReplySubmit(reply);
                onUpdateSummary({ 'summary.investmentPreference': reply });
                if (reply === 'islamic') {
                  onUpdateSummary({ 'summary.isSharia': true });
                } else {
                  onUpdateSummary({ 'summary.isSharia': false });
                }
                /** track islamic investor */
                trackIslamicInvestor(tracking, reply);
                trackEvent(eventInvestmentPreferenceSharia(currentLocale, (reply === 'islamic') ? true : false));
                /** */
              }}
              isOptionButton
              rtl={isRtl}
            />
          );
          break;
        case COMPONENT_TYPE.INVEST_IN_GOLD:
          input = (
            <ButtonList
              optionList={inputOptions}
              onOptionClick={(reply) => {
                // onReplySubmit(this.processGeographicalReply(reply), { toTranslate: false });
                onReplySubmit(reply);
                if (reply === 'yes_gold') {
                  onUpdateSummary({ 'summary.geographicalInterest': 'askGeographically.convo.quick_replies.5' });
                  /** Tracking Geographical Investment */
                  trackGeographicalInvestment(tracking, 'gold_investment');
                } else {
                  onUpdateSummary({ 'summary.geographicalInterest': 'not_applicable' });
                }
                // /** track islamic investor */
                // trackIslamicInvestor(tracking, reply);
                /** */
              }}
              isOptionButton
              rtl={isRtl}
            />
          );
          break;

        case COMPONENT_TYPE.GEOGRAPHICALLY:
          input = (
            <ButtonList
              optionList={inputOptions}
              onOptionClick={(reply) => {
                onReplySubmit(this.processGeographicalReply(reply), { toTranslate: false });
                onUpdateSummary({ 'summary.geographicalInterest': reply });
                /** Tracking Geographical Investment */
                trackGeographicalInvestment(tracking, reply);
                trackEvent(eventInvestmentPreferenceCountry(currentLocale, summary['summary.isSharia'], this.processGeographicalReply(reply)));
                /** */
              }}
              isCheckbox
              rtl={isRtl}
            />
          );
          break;
        case COMPONENT_TYPE.QUALIFIED_INVESTOR:
          const translateOptions = {
            textQualified: CMAClassification === 'CMAClassification.Qualified'
              ? intl.formatMessage({ id: 'investment_preference.yes' }) : intl.formatMessage({ id: 'investment_preference.no' }),
            textRetail: CMAClassification === 'CMAClassification.Retail'
              ? intl.formatMessage({ id: 'investment_preference.yes' }) : intl.formatMessage({ id: 'investment_preference.no' }),
          };
          input = (
            <ButtonList
              optionList={inputOptions}
              onOptionClick={(reply) => {
                onReplySubmit(reply, { translateOptions, toTranslate: true });
                onUpdateSummary({ 'summary.regulatoryClassification': reply });
                /** track Regulatory investors */
                trackRegulatoryInvestor(tracking, reply);
                /** */
              }}
              isOptionButton
              translateOptions={translateOptions}
              rtl={isRtl}
            />
          );
          break;
        default:
          input = '';
      }

      return (
        <LayoutChat
          conversations={conversations}
          input={input}
          navTitle="investmentPreference.title"
          subTitle={intl.formatMessage({ id: 'journey.step' }, { number: 3 })}
          leftButton={<FontAwesomeIcon icon={faRedo} />}
          onLeftClick={this.handleRestart}
          rightButton={<img src={iconClose} alt="X" />}
          onRightClick={this.closeInvestorProfile}
          {...this.props}
        />
      );
    }
}

const mapStateToProps = state => ({
  conversations: state.rootReducer.investmentPreference,
  inputComponent: state.rootReducer.inputComponent,
  inputOptions: state.rootReducer.inputOptions,
  CMAClassification: state.rootReducer.CMAClassification,
  isRtl: getRTL(state.rootReducer),
  currentLocale: state.rootReducer.language.locale,
  summary: state.rootReducer.summary,
});

const mapDispatchToProps = ({
  onReplySubmit: submitReply,
  onClearConversationHistory: clearConversationHistory,
  onUpdateSummary: updateSummary,
  onUpdateStep: updateStep,
});

export default track({
  page: 'InvestmentPreference',
})(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(InvestmentPreference)));
